const columns = [
  {
    field: "id",
    headerName: "ID",
    inputType: "text",
    width: 180,
    isDisabled: true,
    hideInput: true,
  },
  {
    field: "providerName",
    headerName: "Provider name*",
    sortable: true,
    inputType: "text",
    width: 180,
    isDisabled: false,
  },
  {
    field: "facebook",
    headerName: "Facebook",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "instagram",
    headerName: "Instagram",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "x",
    headerName: "X (Twitter)",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "tiktok",
    headerName: "Tiktok",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "whatsapp",
    headerName: "WhatsApp",
    inputType: "text",
    width: 150,
    editable: false,    
  },
  {
    field: "region",
    headerName: "Region",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "branch",
    headerName: "Branch",
    inputType: "select9",
    hide: false,
    width: 150,
    editable: false,
    data9: "Branch",
  },
  {
    field: "email",
    headerName: "Email*",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "password",
    headerName: "Password",
    inputType: "password",
    width: 150,
    hide: true,
    editable: false,
  },
  {
    field: "verifyPassword",
    headerName: "Enter password again",
    inputType: "password",
    hide: true,
    width: 150,
    editable: false,
  },
  {
    field: "address",
    headerName: "Address",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "telephone",
    headerName: "Telephone",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "domain",
    headerName: "Domain",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "description",
    headerName: "Description",
    inputType: "multiText", // or 'text' if you want a single-line input
    width: 200,
    editable: false,
  },
  {
    field: "openTime",
    headerName: "Order Start time",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "deliveryCircle",
    headerName: "Delivery Circle",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "deliveryCost",
    headerName: "Delivery Cost",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "deliveryApproxTime",
    headerName: "Delivery Time (min)",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "minOrderCost",
    headerName: "Minimum Order Cost",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "logo",
    headerName: "Provider Logo",
    inputType: "file",
    width: 150,
    editable: false,
    fileType: ["jpg", "jpeg", "png"],
  },
  {
    field: "community",
    headerName: "Community",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "postcode",
    headerName: "Postal Code",
    inputType: "text",
    width: 150,
    editable: false,
  },
  {
    field: "number",
    headerName: "Number",
    inputType: "text",
    type: "number",
    width: 150,
    editable: false,
  },
  {
    field: "paypalMode",
    headerName: "Allow Paypal",
    inputType: "switch",
    width: 150,
    editable: false,
    valueGetter: (params) => (params.row.paypalMode ? "Yes" : "No"),
  },
  {
    field: "paypalClientId",
    headerName: "Enter Paypal Client Id",
    inputType: "text",
    width: 150,
    editable: false,
    hideInput: true,
    hide: true,
  },
  {
    field: "paypalClientSecret",
    headerName: "Enter Paypal Client Secret",
    inputType: "text",
    width: 150,
    hide: true,
    editable: false,
    hideInput: true,
  },
  {
    field: "cashMode",
    headerName: "Allow Cash",
    inputType: "switch",
    width: 150,
    editable: false,
    valueGetter: (params) => (params.row.cashMode ? "Yes" : "No"),
  },
  {
    field: "Abholung",
    headerName: "Abholung",
    inputType: "switch",
    width: 150,
    editable: false,
    valueGetter: (params) => (params.row.Abholung ? "Yes" : "No"),
  },
  {
    field: "Lieferung",
    headerName: "Lieferung",
    inputType: "switch",
    width: 150,
    editable: false,
    valueGetter: (params) => (params.row.Lieferung ? "Yes" : "No"),
  },
  {
    field: "iswelcome",
    headerName: "Welcome Page",
    inputType: "switch",
    width: 150,
    editable: false,
    valueGetter: (params) => (params.row.iswelcome ? "Yes" : "No"),
  },
  {
    field: "availability",
    headerName: "Open",
    inputType: "switch",
    width: 120,
    isDisabled: false,
    valueGetter: (params) => (params.row.availability ? "Yes" : "No"),
  },
  {
    field: "emailVerified",
    headerName: "Email verified",
    inputType: "switch",
    width: 120,
    isDisabled: true,
    valueGetter: (params) => (params.row.emailVerified ? "Yes" : "No"),
  },
  {
    field: "deactivate",
    headerName: "Deactivated",
    inputType: "switch",
    width: 150,
    editable: false,
    valueGetter: (params) => (params.row.deactivate ? "Yes" : "No"),
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 150,
    sortable: false,
    renderCell: (params) => {
      return {
        type: "actions",
        providerId: params.row.id,
      };
    },
  },
];

export default columns;
